import ListBulkActionButton from './ListBulkActionButton'

export default ListBulkActionButton
